import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import HttpManager from "../../../../services/HttpManager";
import { InvitationPreviewDTO } from "../../../../models/WorkshopDTO";
import { WorkshopMultiDetailDTO, WorkshopPreviewDTO } from "../../../../services/v2/workshops.service";
import { BotonWhatsappAlumno, useVeWappChat } from "../../../../components/whatsapp/whatsappAlumno";
import EnvioMasivo from "../../../../components/whatsapp/envioMasivo";
import useEsTelefono from "../../../../utils/esTelefono";
import { cursoCorto } from "../../../../utils/cursoCorto";
import S from "./strings";
import { Opciones, errorText, useRolDinero } from "./comun";
import { Chip, QueVaAPasar, Ventana, monto } from "./piezasTaller";

/*
	«+ Inscribir» and «Invitar» of the workshop window (Módulos Claros, 2026-11-01). Neither charges on the first click any
	more: choosing a student (or «Inscribir N») asks the server what will happen (GET _preview) and only «Confirmar» enrolls.
*/

/** Search a student, then «Qué Va a Pasar», then enroll. Money roles may type another price with its reason. */
export const Inscribir: React.FC<{ campusId: number; taller: WorkshopMultiDetailDTO; rolDinero: boolean; onClose: () => void;
	onDone: (t: WorkshopMultiDetailDTO, texto: string) => void }> = ({ campusId, taller, rolDinero, onClose, onDone }) => {
	const http = HttpManager.getInstance();
	const [q, setQ] = useState<string>("");
	const [found, setFound] = useState<{ id: number; name: string; code: string }[] | null>(null);
	const [cobra, setCobra] = useState<boolean>((taller.price || 0) > 0);
	const [precio, setPrecio] = useState<string>(String(taller.price ?? ""));
	const [motivo, setMotivo] = useState<string>("");
	const [vista, setVista] = useState<{ alumna: { id: number; name: string }; v: WorkshopPreviewDTO } | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const distinto = cobra && rolDinero && precio.trim() !== "" && !isNaN(Number(precio)) && Math.abs(Number(precio) - (taller.price || 0)) > 0.004;
	const extra = () => ({ charge: cobra, price: cobra && rolDinero && precio !== "" ? Number(precio) : undefined, priceNote: distinto ? motivo.trim() : undefined });

	const buscar = () => {
		if (q.trim().length < 2) return;
		setError(null);
		http.studentService.getStudentsByCampusId(campusId, 10, { search: q.trim() })
			.then((r: any) => setFound((r.data?.data || []).map((s: any) => ({ id: s.id, name: `${s.firstName || ""} ${s.lastName || ""}`.trim(), code: s.identityCode || s.correlative || "" }))))
			.catch(() => setFound([]));
	};
	const elegir = (s: { id: number; name: string }) => {
		setBusy(true); setError(null);
		http.workshopsService.preview(campusId, taller.id, "inscribir", { studentIds: [s.id], ...extra() })
			.then((r) => setVista({ alumna: s, v: r.data }))
			.catch((e) => setError(errorText(e)))
			.finally(() => setBusy(false));
	};
	const confirmar = () => {
		if (!vista) return;
		setBusy(true); setError(null);
		const x = extra();
		http.workshopsService.addAttendee(campusId, { workshopId: taller.id, studentId: vista.alumna.id, charge: x.charge, price: x.price, priceNote: x.priceNote })
			.then((r) => onDone(r.data as WorkshopMultiDetailDTO, S.inscrita(vista.alumna.name)))
			.catch((e) => { setError(errorText(e)); setBusy(false); });
	};

	return (
		<>
			<Ventana titulo={<>{S.inscribirTitulo}<span className="wtlSub" style={{ fontSize: 14 }}>{taller.name}</span></>} onClose={onClose} busy={busy}
				pie={<button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose} disabled={busy}>{S.cancelar}</button>}>
				<div className="wau-fila" style={{ marginBottom: 10 }}>
					{rolDinero || (taller.price || 0) <= 0 ? <label className="wau-campo" style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
						<input type="checkbox" checked={cobra} onChange={(e) => setCobra(e.target.checked)} /><span>{S.seCobra}</span></label> : null}
					{cobra ? (rolDinero
						? <label className="wau-campo" style={{ width: 150 }}><span className="wau-lab">{S.precio}</span>
							<input type="number" min={0} step="0.01" className="wau-entrada wau-num" value={precio} onChange={(e) => setPrecio(e.target.value)} /></label>
						: <div className="wau-campo"><span className="wau-lab">{S.precio}</span><span className="wau-num">{monto(taller.currency, taller.price)}</span></div>) : null}
					{cobra && taller.priceStudent ? <div className="wau-campo"><span className="wau-lab">{S.precioMatriculada}</span><span className="wau-num">{monto(taller.currency, taller.priceStudent)}</span></div> : null}
					{distinto ? <label className="wau-campo" style={{ flex: "1 1 200px" }}><span className="wau-lab">{S.motivoPrecio}</span>
						<input className="wau-entrada" maxLength={255} value={motivo} onChange={(e) => setMotivo(e.target.value)} /></label> : null}
				</div>
				<div className="wau-fila">
					<input type="search" className="wau-entrada" style={{ flex: "1 1 220px" }} placeholder={S.buscarAlumna} value={q} autoFocus
						onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") buscar(); }} />
					<button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy || q.trim().length < 2} onClick={buscar}>{S.buscarBtn}</button>
				</div>
				{found === null ? null : (
					<div className="waResultados">
						{found.length === 0 ? <div className="wtlSub" style={{ padding: 10 }}>{S.sinResultados}</div> : found.map((s) => {
							const ya = taller.attendees.some((a) => a.studentId === s.id && a.status === 1);
							return (
								<button key={s.id} type="button" className="waResultado" disabled={busy || ya} onClick={() => elegir(s)}>
									<span><b>{s.name}</b> {ya ? <Chip>{S.yaInscrita}</Chip> : null}</span><span className="wtlSub">{s.code}</span>
								</button>
							);
						})}
					</div>
				)}
				{error && !vista ? <div className="waAviso" role="alert">{error}</div> : null}
			</Ventana>
			{vista ? <QueVaAPasar vista={vista.v} boton={S.confirmar} busy={busy} error={error} onCancel={() => { setVista(null); setError(null); }} onConfirm={confirmar} /> : null}
		</>
	);
};

/** WhatsApp invitation (approved template, existing flow) + «Inscribir N» with «Qué Va a Pasar». */
export const Invitar: React.FC<{ campusId: number; taller: WorkshopMultiDetailDTO; opciones: Opciones; onClose: () => void;
	onInscritas: (texto: string, ok: boolean) => void }> = ({ campusId, taller, opciones, onClose, onInscritas }) => {
	const http = HttpManager.getInstance();
	const navigate = useNavigate();
	const movil = useEsTelefono();
	const veWa = useVeWappChat();
	const rolDinero = useRolDinero(campusId);
	const [cobra, setCobra] = useState<boolean>((taller.price || 0) > 0);
	const [cursos, setCursos] = useState<number[]>(() => (taller.courses || []).map((c) => c.id).concat(!taller.courses?.length && taller.courseId ? [taller.courseId] : []));
	const [vista, setVista] = useState<InvitationPreviewDTO | null>(null);
	const [quitar, setQuitar] = useState<number[]>([]);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const [masivo, setMasivo] = useState<boolean>(false);
	const [qvp, setQvp] = useState<WorkshopPreviewDTO | null>(null);
	const lista = [...opciones.cursos];
	(taller.courses || []).forEach((c) => { if (!lista.some((x) => x.id === c.id)) lista.unshift({ id: c.id, name: cursoCorto(c.name) || c.name }); });

	const ver = () => {
		if (cursos.length === 0) { setError(S.elegirCurso); return; }
		setBusy(true); setError(null);
		http.workshopsService.invitationPreview(campusId, taller.id, cursos)
			.then((r) => { setVista(r.data); setQuitar(r.data.recipients.filter((x) => x.alreadyEnrolled).map((x) => x.studentId)); })
			.catch((e) => setError(errorText(e)))
			.finally(() => setBusy(false));
	};
	const elegidas = (vista?.recipients || []).filter((r) => !quitar.includes(r.studentId));
	const porInscribir = elegidas.filter((r) => !r.alreadyEnrolled);
	const pedirInscribir = () => {
		setBusy(true); setError(null);
		http.workshopsService.preview(campusId, taller.id, "inscribir", { studentIds: porInscribir.map((r) => r.studentId), charge: cobra })
			.then((r) => setQvp(r.data))
			.catch((e) => setError(errorText(e)))
			.finally(() => setBusy(false));
	};
	const inscribir = () => {
		if (!qvp) return;
		const ids = qvp.people.filter((p) => !p.blocked).map((p) => p.studentId);
		setBusy(true); setError(null);
		http.workshopsService.addAttendeesBulk(campusId, taller.id, ids, cobra)
			.then((r) => {
				const s = (r.data.skipped || []).length;
				onInscritas(S.inscritasOk(r.data.added, s), s === 0);
				setQvp(null);
				setVista((v) => v ? { ...v, recipients: v.recipients.map((x) => ids.includes(x.studentId) && !r.data.skipped.some((k) => k.studentId === x.studentId) ? { ...x, alreadyEnrolled: true } : x) } : v);
			})
			.catch((e) => setError(errorText(e)))
			.finally(() => setBusy(false));
	};
	const d = vista?.data;
	const fijos: Record<string, string> = d ? { fecha: d.fecha, horarios: d.hora, precio: d.precio, monto: d.precio, dato: d.taller } : {};
	const alternar = (id: number) => setQuitar((q) => q.includes(id) ? q.filter((x) => x !== id) : [...q, id]);

	return (
		<>
			<Ventana titulo={<>{S.invitarTitulo}<span className="wtlSub" style={{ fontSize: 14 }}>{taller.name}</span></>} onClose={onClose} busy={busy} pie={<>
				<button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose} disabled={busy}>{S.cerrar}</button>
				<button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => navigate("/plantillas")}>{S.crearPlantilla}</button>
				<span style={{ flex: 1 }} />
				{vista && porInscribir.length > 0 ? <>
					{rolDinero || (taller.price || 0) <= 0 ? <label className="wau-campo" style={{ flexDirection: "row", alignItems: "center", gap: 6 }}><input type="checkbox" checked={cobra} onChange={(e) => setCobra(e.target.checked)} /><span>{S.seCobra}</span></label> : null}
					<button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy} onClick={pedirInscribir}>{S.inscribirN(porInscribir.length)}</button>
				</> : null}
				{vista && veWa && elegidas.length > 0 ? <button type="button" className="btn btn-primary btn-sm" disabled={busy} onClick={() => setMasivo(true)}>{S.enviarInvitacion(elegidas.length)}</button> : null}
			</>}>
				<div className="wte-cursos" role="group" aria-label={S.cursos} style={{ marginBottom: 8 }}>
					{lista.map((c) => (
						<button key={c.id} type="button" className="wau-chip" aria-pressed={cursos.includes(c.id)}
							onClick={() => { setVista(null); setCursos((cs) => cs.includes(c.id) ? cs.filter((x) => x !== c.id) : [...cs, c.id]); }}>{c.name}</button>
					))}
				</div>
				<div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
					<button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy || cursos.length === 0} onClick={ver}>{S.verDestinatarias}</button>
					{vista ? <span className="wtlSub">{S.destinatarias(vista.total)}</span> : null}
				</div>
				{error && !qvp ? <div className="waAviso" role="alert">{error}</div> : null}
				{!vista ? null : movil ? (
					<div style={{ marginTop: 10 }}>
						{vista.recipients.map((r) => (
							<div key={r.studentId + "_" + r.enrollmentId} style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center", padding: "6px 0", borderBottom: "1px solid var(--wa-filo)" }}>
								<label className="wte-check" style={{ minWidth: 0 }}><input type="checkbox" checked={!quitar.includes(r.studentId)} aria-label={r.name} onChange={() => alternar(r.studentId)} />
									<span><b>{r.name}</b>{r.alreadyEnrolled ? <> <Chip tono="acento">{S.yaInscrita}</Chip></> : null}<div className="wtlSub">{[r.courseName, r.phone].filter(Boolean).join(", ")}</div></span></label>
								<BotonWhatsappAlumno campusId={campusId} studentId={r.studentId} nombre={r.name} />
							</div>
						))}
					</div>
				) : (
					<table className="table table-sm wtlTabla" style={{ marginTop: 10 }}>
						<thead><tr><th style={{ width: 32 }} /><th>{S.colAlumna}</th><th>{S.colCurso}</th><th>{S.colTel}</th><th style={{ width: 48 }} /></tr></thead>
						<tbody>
							{vista.recipients.map((r) => (
								<tr key={r.studentId + "_" + r.enrollmentId}>
									<td><input type="checkbox" checked={!quitar.includes(r.studentId)} aria-label={r.name} onChange={() => alternar(r.studentId)} /></td>
									<td><b>{r.name}</b>{r.alreadyEnrolled ? <> <Chip tono="acento">{S.yaInscrita}</Chip></> : null}</td>
									<td>{cursoCorto(r.courseName) || r.courseName}</td>
									<td className="wau-num">{r.phone || "—"}</td>
									<td><BotonWhatsappAlumno campusId={campusId} studentId={r.studentId} nombre={r.name} /></td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</Ventana>
			{masivo ? <EnvioMasivo campusId={campusId} studentIds={elegidas.map((r) => r.studentId)} origen="taller" referencia={taller.name || null}
				fijosIniciales={fijos} onClose={() => setMasivo(false)} /> : null}
			{qvp ? <QueVaAPasar vista={qvp} boton={S.inscribirN(qvp.ok)} busy={busy} error={error} onCancel={() => { setQvp(null); setError(null); }} onConfirm={inscribir} /> : null}
		</>
	);
};
